import React from "react";
import ErhWorkspace from "./ErhWorkspace";
export default function SchoolErhWorkspace() { return <ErhWorkspace role="school" />; }
